/**
 * OMR Bubbles Component
 * Renders the answer bubbles (A, B, C, D, E) for a question
 */

import React from 'react';
import { getAlternativesPositions } from '../../utils/omr/geometryCalc';
import {
  BUBBLE_DIAMETER_MM,
  BUBBLE_LETTER_FONT_SIZE_PT,
  ALTERNATIVES,
} from '../../utils/omr/constants';

const OMRBubbles = ({ questionYMm, questionNumber }) => {
  const positions = getAlternativesPositions(questionYMm);

  // Calcula a posição relativa do primeiro bubble
  const firstBubble = positions[0];
  const totalWidth = positions[positions.length - 1].x - firstBubble.x + BUBBLE_DIAMETER_MM;
  const startOffset = firstBubble.x;

  return (
    <div
      className="omr-bubbles"
      data-testid={`question-bubbles-${questionNumber}`}
      style={{
        display: 'flex',
        gap: '2mm',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      {positions.map((pos) => (
        <div
          key={`bubble-${pos.alternative}`}
          style={{
            position: 'absolute',
            left: `${pos.x}mm`,
            top: `${pos.y}mm`,
            width: `${pos.diameter}mm`,
            height: `${pos.diameter}mm`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          className="omr-bubble-container"
        >
          {/* Bubble circle */}
          <div
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              border: '0.5pt solid #000000',
              borderRadius: '50%',
              backgroundColor: '#FFFFFF',
              flexShrink: 0,
            }}
            className="omr-bubble"
          />

          {/* Letter label (A, B, C, D, E) - CENTERED INSIDE BUBBLE */}
          <div
            style={{
              position: 'relative',
              zIndex: 1,
              fontSize: `${BUBBLE_LETTER_FONT_SIZE_PT}pt`,
              fontWeight: 'bold',
              color: '#000000',
              lineHeight: '1',
            }}
          >
            {pos.alternative}
          </div>
        </div>
      ))}
    </div>
  );
};

export default OMRBubbles;
